<template>
  <div class="main">
    <TabListCon :divType="divTypes"></TabListCon>
    <img src="../../static/imgs/bg2.png" class="img" />
    <div class="titleText">
      <div class="titleName">铭安资讯</div>
      <div class="textMs">做与时俱进并面向未来的开拓者实践者</div>
    </div>
    <div class="box">
      <div v-for="(item, index) in listData" :key="index" @click="handleDetails(item.id)">
        <a :href="item.contentUrl" target="_blank">
          <div class="newsInformationMain">
            <img :src="item.newsImg[0]" class="xwImg" />
            <div class="newsInformationList">
              <div class="title">{{ item.title }}</div>
              <div class="text">
                {{ item.des }}
              </div>
              <div class="time">{{ item.startTime }}</div>
            </div>
          </div>
        </a>
      </div>
      <div class="pageNum">
        <div class="num">共{{ total }}条，共 {{ pageLeng }}页</div>
        <van-pagination v-model="currentPage" :total-items="total" :page-count="pageLeng" force-ellipses
          class="pagination" @change="handlePage" />
      </div>
    </div>
    <BottomContentCon></BottomContentCon>
  </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
import { articlesList, articlesDetails } from "@/utils/api";//调接口引入
export default {
  name: "Home",
  data() {
    return {
      total: -1,
      pageLeng: -1,
      divTypes: '4',//顶部Tab组件的index值
      listData: [],
      listQuery: {
        categoryId: 1,
        pageNo: 1,
        pageSize: 5,
      },
      currentPage: 1,
      pageSize: 5,
    }
  },
  components: { TabListCon, BottomContentCon },
  created() {
    this.newsInformationData()
  },
  methods: {
    handleDetails(e) {
      console.log(e)
      let list = {
        id: e
      }
      articlesDetails(list).then(res => {
        const { data, code, message } = res
        console.log('data', data)
        if (code == 0) {
          if (data.type == 2) {
            window.open('https://www.baidu.com/', '_blank')
          } else {
            this.$router.push({ path: '/RichText', params: { rich: data.content } })
          }

        } else {
          this.$toast.fail(message);
        }
      })
    },
    handlePage() {
      if (this.listQuery.pageNo < this.pageLeng) {
        this.listQuery.pageNo++
        this.newsInformationData()
      }
    },
    newsInformationData() {
      articlesList(this.listQuery).then(res => {
        const { data, code, message } = res
        if (code == 0) {
          this.listData = data.list
          this.total = data.total
          this.pageLeng = Math.ceil(data.total / this.pageSize)

        } else {
          this.$toast.fail(message);
        }
      })
    },

  }
};
</script>

<style scoped>
.textMs {
  color: rgba(255, 255, 255, 0.8);
  font-size: 40px;
}

.titleName {
  color: #fff;
  font-size: 80px;
}

.titleText {
  padding: 145px;
  width: 1500px;
  margin-top: -550px;
}

.pageNum {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 80px;
  padding: 24px;
}

.pagination {
  width: 400px;
}

.num {
  font-size: 21px;
  color: #747683;
}

.time {
  color: #6D6D6D;
  font-size: 21px;
  margin-top: 64px;
}

.text {
  width: 1051px;
  color: #6D6D6D;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 21px;
  margin-top: 32px;
  line-height: 42px;
}

.newsInformationMain {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 48px;
}

.title {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  width: 1050px;
}

.newsInformationList {
  padding: 48px;
}

.xwImg {
  width: 454px;
  height: 348px;
  display: block;
  border-radius: 8px;
}

.newsInformationList {
  padding: 48px;
}

.box {
  padding: 160px 120px 0 120px;
}

.img {
  width: 100%;
  height: 693px;
}
</style>